/* eslint-disable spellcheck/spell-checker */
import { Environment } from './environment.model';

export const environment: Environment = {
    production: false,
    ws: {
        url: 'wss://rocket.imaxagaming.com:9779/n/1f424eb26a7203cb/83dbc76b7c086aab/croupier',
        reconnectIntervalMs: 10000
    },
    version: 'local',
    languages: [
        { code: 'en', label: 'English', flagSymbol: '🇬🇧' },
        { code: 'it', label: 'Italiana', flagSymbol: '🇮🇹' },
        { code: 'sl', label: 'Slovenščina', flagSymbol: '🇸🇮' }
    ]
};
